import React from 'react';
import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import FormLabel from 'v2/form/FormLabel/FormLabel';

export interface DataProductRestrictionFormFields {
  title: string;
  restriction: string;
}

const DataProductRestrictionForm = () => {
  const { register } = useFormContext<DataProductRestrictionFormFields>();

  return (
    <>
      <div>
        <FormLabel label={`Restriction Title`} required={false} />
        <Form.Control
          id="title"
          type="text"
          placeholder="Restriction Title"
          autoComplete="off"
          maxLength={255}
          {...register('title', { required: true })}
        />
      </div>
      <div>
        <FormLabel label={`Restriction Detail`} required={false} />
        <Form.Control
          id="restriction"
          as="textarea"
          placeholder="Restriction Details"
          rows={6}
          autoComplete="off"
          {...register('restriction', { required: true })}
        />
      </div>
    </>
  );
};

export default DataProductRestrictionForm;
